export const strings = {
  externalReviewBannerText: userName => `This period has been locked by '${userName}' as uncategorised data has been exported to categorise manually. `,
  reuploadCompletedData: 'Re-upload completed data',
  inUseText: userName => `This period is in use by '${userName}' and is therefore in read-only mode. `,
  requestControl: 'Request control',
  lockedBannerText: 'This period has been locked and is therefore in read-only mode. ',
  lockedBannerTextWhenChangingSupportingDocs: 'This period has been locked as new supporting documents are being uploaded. Please complete the Mapping process and proceed further. ',
  periodReleaseText: 'This period has been released. ',
};